"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TypingTest = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.date.now.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/web.timers.js");
require("core-js/modules/es.promise.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactDeviceDetect = require("react-device-detect");
var _formElements = require("@evidation/form-elements");
var _reactTypingTest = require("@evidation-shared/react-typing-test");
var _styledReactModal = require("styled-react-modal");
var _components = require("./components");
require("@evidation-shared/react-typing-test/lib/style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // Default styling for the typing test
var handleMarkdown = function handleMarkdown(text) {
  return _lodash["default"].isString(text) ? /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, text) : text;
};
var TypingTest = exports.TypingTest = function TypingTest(_ref) {
  var _ref$input = _ref.input,
    onChange = _ref$input.onChange,
    name = _ref$input.name,
    start_prompt = _ref.start_prompt,
    _ref$start_prompt_tit = _ref.start_prompt_title,
    start_prompt_title = _ref$start_prompt_tit === void 0 ? 'Start Prompt Title' : _ref$start_prompt_tit,
    _ref$continue_button = _ref.continue_button,
    continue_button = _ref$continue_button === void 0 ? 'Continue to Test' : _ref$continue_button,
    _ref$typing_prompt_ti = _ref.typing_prompt_title,
    typing_prompt_title = _ref$typing_prompt_ti === void 0 ? 'Typing Prompt Title' : _ref$typing_prompt_ti,
    typing_prompt_instruction = _ref.typing_prompt_instruction,
    typing_prompt = _ref.typing_prompt,
    background_text_color = _ref.background_text_color,
    overlay_text_color = _ref.overlay_text_color,
    minimum_time = _ref.minimum_time,
    timer = _ref.timer,
    image = _ref.image,
    _ref$image_alt = _ref.image_alt,
    image_alt = _ref$image_alt === void 0 ? '' : _ref$image_alt,
    _ref$allow_free_text = _ref.allow_free_text,
    allow_free_text = _ref$allow_free_text === void 0 ? false : _ref$allow_free_text;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    testEnd = _useState4[0],
    setTestEnd = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    startTime = _useState6[0],
    setStartTime = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    log = _useState8[0],
    setLog = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    testResponse = _useState10[0],
    setTestResponse = _useState10[1];
  var _useState11 = (0, _react.useState)(0),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    opacity = _useState12[0],
    setOpacity = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    modal = _useState14[0],
    setModal = _useState14[1];
  var _useState15 = (0, _react.useState)(0),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    secondsElapsed = _useState16[0],
    setSecondsElapsed = _useState16[1];
  var hasImage = !_lodash["default"].isEmpty(image);
  var minCountdown = minimum_time * 60 - secondsElapsed;
  var minTimerText = (0, _reactTypingTest.formatSeconds)(minCountdown);
  var deviceInformation = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, "".concat(name, "_device_os"), _reactDeviceDetect.osName), "".concat(name, "_device_os_version"), _reactDeviceDetect.osVersion), "".concat(name, "_device_timezone"), Intl.DateTimeFormat().resolvedOptions().timeZone);
  if (_reactDeviceDetect.isMobile) {
    deviceInformation["".concat(name, "_device_type")] = _reactDeviceDetect.mobileModel;
    deviceInformation["".concat(name, "_device_vendor")] = _reactDeviceDetect.mobileVendor;
  }
  var startTest = function startTest() {
    setStartTime(Date.now());
    setPage(1);
  };
  var endTest = function endTest() {
    var completed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var endTime = Date.now();
    setTestEnd(true);
    var payload = _objectSpread(_objectSpread((0, _defineProperty2["default"])({}, name, name), deviceInformation), {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, "".concat(name, "_test_completed"), _lodash["default"].toString(completed)), "".concat(name, "_test_duration_ms"), endTime - startTime), "".concat(name, "_time_start"), startTime), "".concat(name, "_time_end"), endTime), "".concat(name, "_test_log"), JSON.stringify(log)));
    if (hasImage) {
      payload["".concat(name, "_image_url")] = image;
    }

    // It is possible to submit the typing test without a response,
    // this handles the issue with empty strings failing BE validation.
    if (_lodash["default"].isEmpty(testResponse) || allow_free_text) {
      payload["".concat(name, "_test_response")] = testResponse;
    }
    onChange(payload);
  };
  var handleTick = function handleTick(_ref2) {
    var secondsElapsed = _ref2.secondsElapsed,
      timedOut = _ref2.timedOut;
    setSecondsElapsed(secondsElapsed);
    if (timedOut) {
      endTest(false);
    }
  };
  var handleKeyPress = function handleKeyPress(key) {
    setLog(function (log) {
      return [].concat((0, _toConsumableArray2["default"])(log), [{
        timestamp: Date.now(),
        key: key
      }]);
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components.TypingTestContainer, null, page === 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components.Heading, null, start_prompt_title), handleMarkdown(start_prompt), /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    id: "t-continue_button",
    onClick: function onClick() {
      startTest();
    },
    buttonStyle: "achievement"
  }, continue_button)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components.Heading, null, typing_prompt_title), handleMarkdown(typing_prompt_instruction), /*#__PURE__*/_react["default"].createElement(_reactTypingTest.TypingTest, {
    id: "".concat(name, "-typing-test"),
    name: "".concat(name, "-typing-test"),
    "data-test-id": "typing-test",
    text: typing_prompt,
    timeout: timer * 60,
    disabled: testEnd,
    imageSrc: image,
    imageAltText: image_alt,
    backgroundTextColor: background_text_color,
    overlayTextColor: overlay_text_color,
    useNativeCaret: true,
    textareaStyle: {
      padding: 5
    },
    backgroundTextStyle: {
      padding: 6
    } // +1 to account for the border on the textarea
    ,
    onTick: handleTick,
    onKeyPress: handleKeyPress,
    onChange: setTestResponse,
    allowFreeText: allow_free_text
  }), !testEnd && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components.Spacer, null), /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    style: {
      marginBottom: '5px'
    },
    id: "t-stop_button",
    "data-test-id": "t-stop_button",
    buttonStyle: "achievement",
    disabled: minimum_time && minCountdown > 0,
    onClick: function onClick() {
      return setModal(true);
    } //required anonymous function to prevent synthetic event warnings
  }, minimum_time && minCountdown > 0 ? "Continue in ".concat(minTimerText) : 'Done')))), /*#__PURE__*/_react["default"].createElement(_styledReactModal.ModalProvider, null, /*#__PURE__*/_react["default"].createElement(_components.StyledModal, {
    isOpen: modal,
    opacity: opacity,
    afterOpen: function afterOpen() {
      return setTimeout(function () {
        return setOpacity(1);
      });
    },
    beforeClose: function beforeClose() {
      return new Promise(function (resolve) {
        setOpacity(0);
        setTimeout(resolve, 200);
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.StyledModal.Content, null, "Are you finished with the typing test?", /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    style: {
      margin: '5px 0'
    },
    onClick: function onClick() {
      setModal(false);
      endTest();
    },
    buttonStyle: "achievement"
  }, "Yes"), /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    style: {
      marginBottom: '5px'
    },
    buttonStyle: "secondary",
    onClick: function onClick() {
      return setModal(false);
    }
  }, "No")))));
};
TypingTest.defaultProps = {
  start_prompt: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "On the next screen you will see an image and a text entry box."), /*#__PURE__*/_react["default"].createElement("p", null, "Describe what you see in the image by writing in the text entry box."), /*#__PURE__*/_react["default"].createElement("p", null, "There is a time limit, but there is no fail or pass.")),
  typing_prompt: 'Typing prompt'
};
TypingTest.propTypes = {
  start_prompt_title: _propTypes["default"].string,
  image: _propTypes["default"].string,
  image_alt: _propTypes["default"].string,
  minimum_time: _propTypes["default"].number,
  timer: _propTypes["default"].number.isRequired,
  input: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    name: _propTypes["default"].string.isRequired
  }),
  allow_free_text: _propTypes["default"].bool
};
var _default = exports["default"] = TypingTest;